export default function ClassRechargeBean() {
    this.payId = -1
    this.title = ''
    this.status = ''
    this.statusCode = -1
    this.percapita = ''
    this.endTime = ''
    this.remarks = ''
    this.money = ''
    this.totalPerson = []
    this.paid = []
}